import { createSlice } from "@reduxjs/toolkit";
import { UserResponseDto } from "../../shared/dtos/user/UserResponseDto";
import { UserSummaryDto } from "../../shared/dtos/user/UserSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const userSlice = createSlice({
  name: "user",
  initialState: getInitialCrudState<UserResponseDto, UserSummaryDto>(),
  reducers: {
    ...generateCrudReducers<UserResponseDto, UserSummaryDto>(),
  },
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
